
export default {
  name: 'BrazilFlag',
};
